import { type CustomRole, type Member, type RoleAttributeMap } from '../../../model';

export type RoleAttributeData = {
  name: string;
  values: string[];
};

export const extractRoleAttributesForMember = (member: Member, role: CustomRole): RoleAttributeData[] => {
  const memberRoleAttributes = member?.roleAttributes || ({} as RoleAttributeMap);
  const roleString = JSON.stringify(role);

  return Object.entries(memberRoleAttributes)
    .filter(([attributeName]) => roleString.includes(attributeName))
    .map(([name, values]) => ({ name, values }));
};

export const extractTeamRoleAttributes = (
  teamRoleAttributes: { [key: string]: string[] },
  role: CustomRole,
): RoleAttributeData[] => {
  const roleString = JSON.stringify(role);

  return Object.entries(teamRoleAttributes)
    .filter(([attributeName]) => roleString.includes(attributeName))
    .map(([name, values]) => ({ name, values }));
};
